import { FC } from 'react';


interface Props {
    className?: string;
    alt?: string;
  }


const Logo: FC<Props> = ({
    className,
    alt,
    ...rest
  }) => {
  
  return (

      <p>Logo</p>
    // <img src={logo} alt={alt} className={className} {...rest} />
  );
};

export default Logo;
